import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-57d849ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "create-car" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))
const _hoisted_4 = {
  key: 0,
  class: "px-4 py-3 mt-6 bg-white border"
}
const _hoisted_5 = {
  key: 0,
  class: "flex items-center justify-center"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm block ml-2 text-gray-400" }, "Загрузка данных автомобиля...", -1))
const _hoisted_7 = {
  key: 1,
  class: "flex flex-col items-center"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-red-400" }, "При загрузке данных автомобиля произошла ошибка", -1))
const _hoisted_9 = {
  key: 1,
  class: "border px-4 py-3 mt-6 bg-white"
}
const _hoisted_10 = { class: "flex items-center justify-end mt-6" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_loader = _resolveComponent("loader")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_select = _resolveComponent("the-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_page_title, { title: "Редактирование автомобиля" }),
      _createVNode(_component_the_button, {
        class: "second small text",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/couriers/cars')))
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createTextVNode(" Назад ")
        ]),
        _: 1
      })
    ]),
    (_ctx.car_state.is_loading || _ctx.car_state.is_failed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_ctx.car_state.is_loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_loader, { class: "primary small" }),
                _hoisted_6
              ]))
            : (_ctx.car_state.is_failed)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _hoisted_8,
                  _createVNode(_component_the_button, {
                    class: "primary text small mt-2",
                    disabled: _ctx.car_state.is_loading,
                    onClick: _ctx.loadCar
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Перезагрузить ")
                    ]),
                    _: 1
                  }, 8, ["disabled", "onClick"])
                ]))
              : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createVNode(_component_the_input, {
            placeholder: "Гос. номер",
            value: _ctx.state.number,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.number) = $event)),
            "is-invalid": _ctx.state_form$.number.$error,
            "validation-errors": _ctx.state_form$.number.$errors,
            disabled: _ctx.is_loading
          }, null, 8, ["value", "is-invalid", "validation-errors", "disabled"]),
          _createVNode(_component_the_input, {
            class: "mt-3",
            placeholder: "Модель",
            value: _ctx.state.model,
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.model) = $event)),
            "is-invalid": _ctx.state_form$.model.$error,
            "validation-errors": _ctx.state_form$.model.$errors,
            disabled: _ctx.is_loading
          }, null, 8, ["value", "is-invalid", "validation-errors", "disabled"]),
          _createVNode(_component_the_select, {
            class: "mt-4",
            placeholder: "Компания",
            value: _ctx.state.company_id,
            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.company_id) = $event)),
            "is-invalid": _ctx.state_form$.company_id.$error,
            "validation-errors": _ctx.state_form$.company_id.$errors,
            disabled: _ctx.is_loading,
            loading: _ctx.data_state.carriers.is_loading,
            failed: _ctx.data_state.carriers.is_failed,
            "error-text": "При получении списка компаний произошла ошибка",
            options: _ctx.data_state.carriers.list,
            "infinite-scroll": "",
            onRefresh: _cache[4] || (_cache[4] = ($event: any) => (_ctx.loadCarriers(_ctx.data_state.carriers.pagination.current_page))),
            onLoadmore: _cache[5] || (_cache[5] = ($event: any) => (_ctx.loadMoreCarriers(_ctx.data_state.carriers.pagination.current_page + 1))),
            onSearch: _ctx.searchCarriers,
            onOptionBySearch: _ctx.unshiftFindedCarrier
          }, null, 8, ["value", "is-invalid", "validation-errors", "disabled", "loading", "failed", "options", "onSearch", "onOptionBySearch"]),
          _createVNode(_component_the_select, {
            class: "mt-4",
            placeholder: "Тип машины",
            searchable: false,
            value: _ctx.state.vehicle_type_id,
            "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.vehicle_type_id) = $event)),
            "is-invalid": _ctx.state_form$.vehicle_type_id.$error,
            "validation-errors": _ctx.state_form$.vehicle_type_id.$errors,
            disabled: _ctx.is_loading,
            loading: _ctx.data_state.vehicle_types.is_loading,
            failed: _ctx.data_state.vehicle_types.is_failed,
            "error-text": "При получении списка типов машин произошла ошибка",
            options: _ctx.data_state.vehicle_types.list,
            "infinite-scroll": "",
            onRefresh: _cache[7] || (_cache[7] = ($event: any) => (_ctx.loadVehicleTypes(_ctx.data_state.vehicle_types.pagination.current_page))),
            onLoadmore: _cache[8] || (_cache[8] = ($event: any) => (
                    _ctx.loadMoreVehicleTypes(_ctx.data_state.vehicle_types.pagination.current_page + 1)
                ))
          }, null, 8, ["value", "is-invalid", "validation-errors", "disabled", "loading", "failed", "options"]),
          _createVNode(_component_the_input, {
            class: "mt-3",
            placeholder: "Кубатура",
            value: _ctx.state.cubature,
            "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.cubature) = $event)),
            "is-invalid": _ctx.state_form$.cubature.$error,
            "validation-errors": _ctx.state_form$.cubature.$errors,
            disabled: _ctx.is_loading
          }, null, 8, ["value", "is-invalid", "validation-errors", "disabled"]),
          _createVNode(_component_the_select, {
            class: "mt-4",
            placeholder: "Грузоподъемность",
            value: _ctx.state.ftl_car_type_id,
            "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.ftl_car_type_id) = $event)),
            "is-invalid": _ctx.state_form$.ftl_car_type_id.$error,
            "validation-errors": _ctx.state_form$.ftl_car_type_id.$errors,
            disabled: _ctx.is_loading,
            loading: _ctx.data_state.ftl_car_types.is_loading,
            failed: _ctx.data_state.ftl_car_types.is_failed,
            "error-text": "При получении списка грузоподъемностей произошла ошибка",
            options: _ctx.data_state.ftl_car_types.list,
            label: "title",
            "search-by": "title",
            onRefresh: _cache[11] || (_cache[11] = ($event: any) => (_ctx.loadFtlCarTypes(_ctx.data_state.ftl_car_types.pagination.current_page)))
          }, null, 8, ["value", "is-invalid", "validation-errors", "disabled", "loading", "failed", "options"]),
          _createVNode(_component_the_input, {
            class: "mt-3",
            placeholder: "Номер тех. паспорта",
            value: _ctx.state.tech_passport_number,
            "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.tech_passport_number) = $event)),
            disabled: _ctx.is_loading
          }, null, 8, ["value", "disabled"]),
          _createVNode(_component_the_input, {
            class: "mt-3",
            placeholder: "Комментарий",
            value: _ctx.state.comment,
            "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.comment) = $event)),
            disabled: _ctx.is_loading
          }, null, 8, ["value", "disabled"]),
          _createVNode(_component_the_input, {
            class: "mt-3",
            placeholder: "Код 1С",
            value: _ctx.state.code_1C,
            "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.code_1C) = $event)),
            disabled: _ctx.is_loading
          }, null, 8, ["value", "disabled"]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_the_button, {
              class: "primary small",
              loading: _ctx.is_loading,
              onClick: _ctx.submitForm
            }, {
              default: _withCtx(() => [
                _hoisted_11,
                _createTextVNode(" Сохранить автомобиль ")
              ]),
              _: 1
            }, 8, ["loading", "onClick"])
          ])
        ]))
  ]))
}